import React from 'react';

import { ReactComponent as StarsLogo } from '../../assets/icons/stars-logo-icon.svg';

import styles from './PurchasePopUp.module.scss';

interface Props {
  onClick: () => void;
}

export const PurchasePopUp: React.FC<Props> = ({ onClick }) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerTitle}>ВЫ ИСПОЛЬЗУЕТЕ БЕСПЛАТНУЮ ВЕРСИЮ</div>
        <div className={styles.headerSubTitle}>Полная версия отчета доступна после оплаты</div>
      </div>

      <button className={styles.ctaButton} onClick={onClick}>
        ПЕРЕЙТИ К ОПЛАТЕ
      </button>

      <StarsLogo className={styles.starsLogo} />
    </div>
  );
};
